import { BuilderComponent } from '@builder.io/react';
import { BuilderContent } from '@builder.io/sdk';
import React, { FC } from 'react';

import ArticleBioBlock from '@/components/article-bio-block/article-bio-block';
import DefaultLayout from '@/components/default-layout';
import Divider from '@/components/divider/divider';
import MetaBlock from '@/components/meta-block/MetaBlock';
import { RelatedArticles } from '@/components/related-articles/related-articles';
import { useLocale } from '@/helpers/LangHelper';
import { FooterMatrix } from '@/helpers/NavHelper';
import globalStyles from '@/styles/generic.module.scss';
import { Article } from '@/types/Article';
import { ChunkedNav } from '@/types/Navigation';

import ArticleHero from '../article-hero/article-hero';
import SocialAndShare from '../content-hub-share-icons/content-hub-share-icons';
import styles from './article-page.module.scss';

export interface ArticlePageProps {
  article?: Article;
  footerItems: FooterMatrix[];
  headerItems: ChunkedNav;
  headerBuilderItems: BuilderContent[] | null;
  stateArticle: Article;
  canonicalUrl: string;
}

const ArticlePage: FC<ArticlePageProps> = ({
  article,
  footerItems,
  headerItems,
  headerBuilderItems,
  stateArticle,
  canonicalUrl,
}) => {
  const { locale } = useLocale();

  if (!article) {
    return <></>;
  }

  let targetUrl = `/${locale}${article.articleUrl}`;
  if (typeof window !== 'undefined') {
    targetUrl = `${window?.origin || ''}/${locale}${article.articleUrl}`;
  }

  return (
    <>
      <MetaBlock
        title={article.seoTitle ?? article.title}
        description={article.seoDescription}
        leadImage={article.leadImage}
        canonicalUrl={canonicalUrl}
      />

      <DefaultLayout
        footerItems={footerItems}
        headerItems={headerItems}
        headerBuilderItems={headerBuilderItems}
      >
        <div className={globalStyles['page-layout']}>
          <ArticleHero article={article} />
          <SocialAndShare shareUrl={targetUrl} />
          <BuilderComponent model="article" content={stateArticle.builderModel} />
          <div className={styles.layoutContainer}>
            <Divider />
            <div className={styles.authorBlock}>
              {article.author && <ArticleBioBlock articleAuthor={article.author} />}
            </div>
          </div>
          <RelatedArticles article={article} offset={0} />
        </div>
      </DefaultLayout>
    </>
  );
};

export default ArticlePage;
